import React from 'react';
import { ExtendReactlytics } from '@americanexpress/reactlytics';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  InfoTooltipButton,
} from '@americanexpress/dls-react';
import { renderHtml } from '../utils/render-html';

interface Props {
  disclaimer: string;
  cardname: string;
  title: string;
}

const DisclaimerTooltip = (props: Props): JSX.Element => {
  const disclaimer = props?.disclaimer;
  const cardname = props?.cardname;
  const title = props?.title;
  const sanitizedDisclaimer = renderHtml(disclaimer);
  const intl = useIntl();

  // eslint-disable-next-line unicorn/consistent-function-scoping -- sup
  const parseEntities = (txt) => new DOMParser().parseFromString(txt, 'text/html').body.textContent;

  return (
    <div
      className="body pad-1-t flex flex-align-center"
      data-testid="disclaimer-tooltip"
    >
      <FormattedMessage
        id="view-all.disclaimer.please-see-disclaimer"
        defaultMessage="Please see Disclaimer"
      />
      <ExtendReactlytics
        analytics={{
          event: { meta: { benefitname: `${parseEntities(title)}` } },
        }}
      >
        <Tooltip disableHover={true} id="tooltip-info-right" placement="top">
          <TooltipTrigger>
            <InfoTooltipButton
              screenReaderLabel="View all disclaimer"
              className="margin-1-l"
              data-testid="tooltip-btn"
              reactlytics={{
                element: `disclaimer>>${cardname?.replace(/ /g, '-').toLowerCase()}`,
              }}
              aria-label={intl.formatMessage({
                id: 'view-all.disclaimer.title',
              })}
            />
          </TooltipTrigger>
          <TooltipContent>{sanitizedDisclaimer}</TooltipContent>
        </Tooltip>
      </ExtendReactlytics>
    </div>
  );
};

export default DisclaimerTooltip;
